import { Navigate } from 'react-router-dom';
import { Appointment, Contacts, Home, NotFound, Pricing, Team } from './views';
import { ServiceDetails, withFadeIn } from './components';
import { Services } from './views/Services';
import { CookiePolicy } from './components/CookiePolicy/CookiePolicy';
import { About } from './views/About';
import { LanguagePreference } from './interface';
import { localizePath } from './utils';

interface CustomRouteObject {
  index?: boolean;
  path?: string;
  element?: JSX.Element;
  backgroundImage?: string;
  children?: CustomRouteObject[];
}

const HomeWithFade = withFadeIn(Home);
const AboutWithFade = withFadeIn(About);
const AppointmentWithFade = withFadeIn(Appointment);
const PricingWithFade = withFadeIn(Pricing);
const TeamWithFade = withFadeIn(Team);
const ContactsWithFade = withFadeIn(Contacts);
const ServicesWithFade = withFadeIn(Services);
const ServiceDetailsWithFade = withFadeIn(ServiceDetails);

const baseRoutes: CustomRouteObject[] = [
  {
    path: '/',
    element: <HomeWithFade />,
    // backgroundImage: '/images/office_25.jpg',
    backgroundImage: 'empty',
  },
  // {
  //   path: '/appointment',
  //   element: <AppointmentWithFade />,
  //   backgroundImage: '/images/office_1.jpeg',
  // },
  {
    path: '/about',
    element: <AboutWithFade />,
    backgroundImage: 'empty',
  },
  {
    path: '/pricing',
    element: <PricingWithFade />,
    backgroundImage: 'empty',
  },
  {
    path: '/team',
    element: <TeamWithFade />,
    backgroundImage: '/images/office_1.jpeg',
  },
  {
    path: '/contacts',
    element: <ContactsWithFade />,
    backgroundImage: '/images/office_1.jpeg',
  },
  {
    path: '/services',
    element: <ServicesWithFade />,
    backgroundImage: '/images/office_1.jpeg',
  },
  {
    path: '/services/:id',
    element: <ServiceDetailsWithFade />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy />,
    backgroundImage: 'empty',

    // backgroundImage: '/images/office_1.jpeg',
  },
  {
    path: '/not-found',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/not-found" />,
  },
];

// English versions of every page live under /en, e.g. /en/pricing
const englishRoutes: CustomRouteObject[] = baseRoutes.map((route) =>
  route.path === '*'
    ? { path: '/en/*', element: <Navigate to="/en/not-found" /> }
    : {
        ...route,
        path: localizePath(route.path!, LanguagePreference.ENGLISH),
      }
);

export const routesConfig: CustomRouteObject[] = [
  ...englishRoutes,
  ...baseRoutes,
];
